const IMPACT_SHOP_PATH = "impact-shop";

export const isImpactShop = (path?: string | string[]) =>
  IMPACT_SHOP_PATH === path;
